export * from './core';
// ttx：按域分层的权威加载入口（顺序即初始化顺序，详见 core/tx/index.js）
import './core/tx';

// 初始化全局状态标志
ttx.__DIWORK_INTEGRATION_MODE__ = ttx.__DIWORK_INTEGRATION_MODE__ || 'none';
ttx.debug = ttx.debug || false;
ttx.rest = ttx.rest || {};
ttx.rest.leftTreeFixedWidth = ttx.rest.leftTreeFixedWidth || 240;
// 全局配置对象：子应用 entry 域名等，可由宿主覆盖
ttx.config = ttx.config || {};

ttx.log.success('🔖 version ' + (ttx.git.getInfo().available ? ttx.git.getInfo().version : '?'));
// Defer so dependent projects (e.g. @xkk/core) registered via ttx.git.register()
// after this module loads are included in the banner.
setTimeout(() => ttx.git.printAll(), 0);

// 版本号挂到 UMD 全局变量 tx（打包时由 rollup git-info 插件替换 __PKG_VERSION__）
export const version = '__PKG_VERSION__';
